import { Component } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { Router } from '@angular/router';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../../core/services/data.service';
import { Subscription } from 'rxjs';
import { TermsService } from 'src/core/services/term.service';

@Component({
  selector: 'app-biometric-login',
  templateUrl: './biometric-login.component.html',
  styleUrls: ['./biometric-login.component.scss'],
})
export class BiometricLoginComponent {
  biometricsActive = false;
  authKeys: any;
  sessionToken!: string | undefined;
  username!: string | undefined;
  password!: string | undefined;
  authSub?: Subscription;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router,
    private nis: NativeIntegrationService,
    private http: HttpClient,
    private dataService: DataService,
    private termsService: TermsService
  ) {}

  loadSession(): void {
    this.authService.loadSession();
  }

  onCodeCompleted(code: string): void {
    this.authService.loadSessionPin(code);
  }

  back(): void {
    // this.dataService.logout();
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
